import { Country } from '@afterpay/types'
import { useConsumerCountry } from '../../state'
import { LaunchDarklyFlags, useFlag } from '../useFlag'

export interface UkRegFlags {
  isGbRegFlow: boolean
  isUkRegImportantInfoEnabled: boolean
  isUkMarketRegsFCA: boolean
  // Flag-only values without country gating. Used by hooks where the country
  // comes from an async response or function parameter rather than Redux,
  // so the consumer applies its own inline country check.
  // - isUkRegsServicingFlagEnabled: used by useLoggedInRedirect (async fetchAccount)
  // - isUkRegImportantInfoFlagEnabled: used by usePostRegistrationRedirect (countryCode param)
  isUkRegsServicingFlagEnabled: boolean
  isUkRegImportantInfoFlagEnabled: boolean
}

export const useUkRegFlags = (): UkRegFlags => {
  const country = useConsumerCountry()
  const isGbCountry = country === Country.GB

  const ukRegsServicingFlag = useFlag(LaunchDarklyFlags.EnableUkRegsServicing)
  const ukRegImportantInfoFlag = useFlag(LaunchDarklyFlags.EnableUkRegImportantInfo)
  const ukMarketRegsFCAFlag = useFlag(LaunchDarklyFlags.UK_MRKT_REGS_FCA)

  const isGbRegFlow = ukRegsServicingFlag && isGbCountry

  return {
    isGbRegFlow,
    isUkRegImportantInfoEnabled: ukRegImportantInfoFlag && isGbCountry,
    isUkMarketRegsFCA: ukMarketRegsFCAFlag && isGbCountry,
    isUkRegsServicingFlagEnabled: ukRegsServicingFlag,
    isUkRegImportantInfoFlagEnabled: ukRegImportantInfoFlag,
  }
}
